module.exports = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,45,50,55,60,65,70,75,80,85,90]


//////////////////
// WEBPACK FOOTER
// ./static/seatTotal.json
// module id = ./static/seatTotal.json
// module chunks = 0 6